/**
 * Barra de formatação de uma face do cartão. Cada botão de texto pede a
 * inserção via `onInserir`; quem escreve no campo é a view. O botão Imagem
 * abre o alvo de arquivo da face via `onAbrirAlvo`, sem alterar o texto do campo.
 */
import {
  Bold,
  Highlighter,
  Image,
  Italic,
  List,
  Sigma,
} from "lucide-react";
import {
  BOTOES_FORMATO,
  type FormatoCartao,
  type FormatoInserivel,
} from "./formatacaoCartao";

export interface FormatToolbarProps {
  /** Which face this bar edits, e.g. "Frente" or "Verso". Used in the accessible name. */
  campo: string;
  /** Text formats only. `imagem` is not passed here. */
  onInserir: (formato: FormatoInserivel) => void;
  /** The Imagem command opens the face's file target. It does not insert text. */
  onAbrirAlvo: () => void;
  disabled?: boolean;
}

const ICONE: Record<FormatoCartao, typeof Bold> = {
  "enfase-forte": Bold,
  enfase: Italic,
  destaque: Highlighter,
  lista: List,
  formula: Sigma,
  imagem: Image,
};

export default function FormatToolbar({
  campo,
  onInserir,
  onAbrirAlvo,
  disabled,
}: FormatToolbarProps): JSX.Element {
  return (
    <div
      role="toolbar"
      aria-label={`Formatação da ${campo}`}
      className="flex flex-wrap gap-2"
    >
      {BOTOES_FORMATO.map(({ id, nome }) => {
        const Icone = ICONE[id];
        return (
          <button
            key={id}
            type="button"
            aria-label={nome}
            disabled={disabled}
            onMouseDown={(event) => {
              event.preventDefault();
            }}
            onClick={() => {
              if (id === "imagem") {
                onAbrirAlvo();
                return;
              }
              onInserir(id);
            }}
            className="inline-flex items-center gap-1.5 rounded-chip border border-edge bg-surface px-2.5 py-1.5 text-xs text-ink hover:bg-surface-hover disabled:cursor-not-allowed disabled:text-ink-muted disabled:hover:bg-surface"
          >
            <Icone size={16} aria-hidden />
            {nome}
          </button>
        );
      })}
    </div>
  );
}
